export const SCHOOL_COUPON_COUNT = 10;

